var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-header"},[_c('div',{staticClass:"title"},[_c('img',{staticClass:"title-icon",attrs:{"src":require("../../assets/image/bg_title.png"),"alt":""}}),_c('span',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"right"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }